import { useEffect, useMemo, useState } from 'react';
import ExternalUserAvatar from 'react-user-avatar';

import { useUserSelector } from 'hooks/useUser';
import { getSelfieViewPresignedUrl } from 'services/profile';

const canUseAvatarDirectly = (avatar) =>
  /^(https?:|data:|blob:)/.test(avatar || '');

const UserAvatar = ({
  size = 40,
  colors = ['#050A25'],
  style = { color: 'white' },
  inlineAvatar = null,
  useInlineAvatar = false
}) => {
  const { userName, user } = useUserSelector();
  const [avatarSrc, setAvatarSrc] = useState();

  const avatar = useMemo(() => {
    if (useInlineAvatar) {
      return inlineAvatar;
    }

    return user?.avatar;
  }, [user, inlineAvatar, useInlineAvatar]);

  useEffect(() => {
    let isMounted = true;

    const resolveAvatar = async () => {
      if (!avatar) {
        setAvatarSrc(undefined);
        return;
      }

      if (canUseAvatarDirectly(avatar)) {
        setAvatarSrc(avatar);
        return;
      }

      setAvatarSrc(undefined);

      try {
        const { signedUrl } = await getSelfieViewPresignedUrl();

        if (isMounted) {
          setAvatarSrc(signedUrl);
        }
      } catch (error) {
        if (isMounted) {
          setAvatarSrc(undefined);
        }
      }
    };

    resolveAvatar();

    return () => {
      isMounted = false;
    };
  }, [avatar]);

  return (
    <ExternalUserAvatar
      size={size}
      name={userName}
      src={avatarSrc}
      colors={colors}
      style={style}
    />
  );
};

export default UserAvatar;
